import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useCookieConsent } from "@/lib/cookieConsent";
import { easeOutStrong } from "@/lib/motion";

export default function CookieBanner() {
    const { bannerOpen, accept, essentialOnly, closeBanner } = useCookieConsent();

    useEffect(() => {
        if (!bannerOpen) return;
        const onKey = (e) => { if (e.key === "Escape") closeBanner(); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [bannerOpen, closeBanner]);

    return (
        <AnimatePresence>
            {bannerOpen && (
                <motion.div
                    initial={{ opacity: 0, y: 100 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 100 }}
                    transition={{ duration: 0.5, ease: easeOutStrong }}
                    role="dialog"
                    aria-label="Cookie preferences"
                    data-testid="cookie-banner"
                    style={{
                        position: "fixed",
                        left: 16, right: 16, bottom: 16,
                        maxWidth: 900, margin: "0 auto", zIndex: 60,
                        background: "rgba(17, 30, 56, 0.92)",
                        border: "1px solid var(--line)",
                        borderRadius: 18,
                        padding: "18px 22px",
                        backdropFilter: "blur(14px)",
                        WebkitBackdropFilter: "blur(14px)",
                        boxShadow: "0 24px 60px -18px rgba(0,0,0,0.65)",
                        color: "var(--text)",
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: 14,
                        justifyContent: "space-between",
                        willChange: "transform, opacity",
                    }}
                >
                    <p style={{ fontSize: 14.5, lineHeight: 1.5, margin: 0, flex: "1 1 320px", color: "var(--muted)" }}>
                        We use only the cookies needed to run this site, plus optional ones to improve it. Accept optional?
                    </p>
                    <div style={{ display: "flex", gap: 8, flex: "0 0 auto" }}>
                        <button
                            type="button"
                            onClick={essentialOnly}
                            className="btn-ghost"
                            data-testid="cookie-essential-btn"
                            style={{ padding: "10px 16px", fontSize: 13.5 }}
                        >
                            Only essential
                        </button>
                        <button
                            type="button"
                            onClick={accept}
                            className="btn-primary"
                            data-testid="cookie-accept-btn"
                            style={{ padding: "10px 18px", fontSize: 13.5 }}
                        >
                            Accept
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
